import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import urls, { codeUrl, cohortUrl } from '@/constants/urls';
import actions from '../constants';

export function* closeTab({ items }) {
  const itemsWithUrls = items.map((item) => cohortUrl(item));

  yield call(listener.closeTab, itemsWithUrls);
}

export function* navigateToNewCohort({ result, code }) {
  yield call(listener.navigate, {
    type: actions.NEW_COHORT,
    code: result.code,
    previousUrl: codeUrl(urls.COHORT, code),
    name: result.name,
    description: result.description,
    url: cohortUrl(result),
  });
}

export function* navigateToNewCohortFromDataset({ code }) {
  yield call(listener.navigate, {
    type: actions.NEW_COHORT_FROM_DATASET,
    url: codeUrl(urls.COHORT, code),
  });
}

export default function* cohortsLayout() {
  yield takeEvery(actions.DESTROY_COHORT, closeTab);
  yield takeEvery(actions.NEW_COHORT, navigateToNewCohort);
  yield takeEvery(actions.NEW_COHORT_FROM_DATASET, navigateToNewCohortFromDataset);
}
